export const AUTH_MODES = {
  KEYCLOAK: 'keycloak',
  SIMULATED: 'simulated',
} as const;
